export default "{\n    \"label\": \"Statut\",\n    \"options\": {\n        \"true\": \"Est actif\"\n    }\n}\n"